module.exports = __webpack_public_path__ + "static/media/about.91b5e3b0.png";